import styled, { css } from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
/**
 * Common colors.
 * Generate a name from HEX color: http://chir.ag/projects/name-that-color
 * If the name already exists, try to be creative by adding a suffix :)
 */


var grayDarkM = '#41434A';
var primaryM = '#924B54';
/**
 * Legacy colors.
 */
// blacks

var black = '#000000';
var blue = '#4978BC';
var blueTint = '#6D93C9';
var darkBlue = '#4B78BA';
var darkerBlue = '#5A85C4';
var lightBlue = '#B1CDEC';
var royalBlue = '#253C5E';
var darkGreen = '#067039';
var green = '#388D61';
var greenTint = '#388D61'; // others (beiges, browns, pinks, purples)

var brown = '#7F4720';
var pink = '#F7ACBC';
var purple = '#1D2E4B';
var red = '#EF4E22';
var redTint = '#F38364'; // yellows

var yellow = '#FBD206';
var yellowTint = '#FCDF50'; // whites

var white = '#FFFFFF';
var darkGrey = '#39393A';
var grey = '#747474';
var lightGrey = '#E3E1DB';
var midGrey = '#ACA6A2';
/**
 * Breakpoints and media queries
 * Following this article #3
 * https://www.freecodecamp.org/news/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862/
 *
 * usage:
 * const StyledComponent = styled(Element)`
     [...]
     ${MQ_FOR_TABLET_PORTRAIT_UP} {
       [...]
     }
   `;
 */

var QUERY_FOR_PHONE_ONLY = "(max-width: 599px) and (orientation: portrait), (max-width: 900px) and (orientation: landscape)";
var MQ_FOR_PHONE_ONLY = "@media ".concat(QUERY_FOR_PHONE_ONLY);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var regular = 400;
var mediumBold = 500;
var semiBold = 600;
var bold = 700;
var primaryFont = "\"Graphik Web\", sans-serif";
var primaryFontM = "\"ProximaNova Web\", Arial, sans-serif";
var headingFontM = "\"GeorgiaPro Web\", Georgia, serif";
var Heading = styled.h3(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
Heading.displayName = 'Heading';
var PageHeader = styled.h3(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: black;\n  font-family: ", ";\n  font-size: 32px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n\n  ", " {\n    font-size: 24px;\n    line-height: 24px;\n  }\n"])), primaryFont, semiBold, MQ_FOR_PHONE_ONLY);
PageHeader.displayName = 'PageHeader';
var H1 = styled.h1(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 50px;\n  font-weight: ", ";\n  line-height: 56px;\n  margin: 0;\n"])), primaryFont, bold);
H1.displayName = 'H1';
var H1M = styled.h1(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 27px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), grayDarkM, headingFontM, semiBold);
H1M.displayName = 'H1M';
var H2 = styled.h2(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 30px;\n  font-weight: ", ";\n  line-height: 40px;\n  margin: 0;\n"])), primaryFont, regular);
H2.displayName = 'H2';
var H3 = styled.h3(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H3.displayName = 'H3';
var H4 = styled.h4(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 20px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n"])), primaryFont, regular);
H4.displayName = 'H4';
var H5 = styled.h5(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, semiBold);
H5.displayName = 'H5';
var H6 = styled.h6(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 20px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, semiBold);
H6.displayName = 'H6';
var H7 = styled.h6(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 24px;\n  margin: 0;\n"])), primaryFont, regular);
H7.displayName = 'H7';
var H8 = styled.h6(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  line-height: 20px;\n  margin: 0;\n"])), primaryFont, regular);
H8.displayName = 'H8';
var H9 = styled.h6(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 12px;\n  font-weight: ", ";\n  letter-spacing: 1px;\n  line-height: 24px;\n  margin: 0;\n  text-transform: uppercase;\n"])), primaryFont, mediumBold);
H9.displayName = 'H9';
var H10 = styled.h6(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 10px;\n  font-weight: ", ";\n  line-height: 12px;\n  margin: 0;\n"])), primaryFont, regular);
H9.displayName = 'H9';
var Text = styled.p(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), primaryFont, regular);
var TextM = styled.p(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-size: 16px;\n  font-weight: ", ";\n  line-height: 125%;\n  margin: 0;\n"])), grayDarkM, primaryFontM, regular);
var Link = styled.a(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), blue, primaryFont, mediumBold);
var LinkM = styled.a(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.5rem;\n  text-decoration: none;\n"])), primaryM, primaryFontM, regular);

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1;
/**
 * Common space styles from props.
 */


var commonSpaceStyles = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (p) {
  return p.mx && computeMarginXHelper(p.mx);
}, function (p) {
  return p.my && computeMarginYHelper(p.my);
}, function (p) {
  return p.mb && computeMarginBottomHelper(p.mb);
}, function (p) {
  return p.ml && computeMarginLeftHelper(p.ml);
}, function (p) {
  return p.mr && computeMarginRightHelper(p.mr);
}, function (p) {
  return p.mt && computeMarginTopHelper(p.mt);
}, function (p) {
  return p.px && computePaddingXHelper(p.px);
}, function (p) {
  return p.py && computePaddingYHelper(p.py);
}, function (p) {
  return p.pb && computePaddingBottomHelper(p.pb);
}, function (p) {
  return p.pl && computePaddingLeftHelper(p.pl);
}, function (p) {
  return p.pr && computePaddingRightHelper(p.pr);
}, function (p) {
  return p.pt && computePaddingTopHelper(p.pt);
}, function (p) {
  return p.p && computePaddingHelper(p.p);
});
/**
 * Box component.
 */

var Box = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", ";\n\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"])), function (p) {
  return commonSpaceStyles;
}, function (p) {
  return p.bg && computeBackgroundColorHelper(p.bg);
}, function (p) {
  return p.borderBottom && "border-bottom: ".concat(p.borderBottom, ";");
}, function (p) {
  return p.borderColor && "border-color: ".concat(p.borderColor, ";");
}, function (p) {
  return p.borderWidth && "border-width: ".concat(p.borderWidth, ";");
}, function (p) {
  return p.w && "width: ".concat(p.w, ";");
}, function (p) {
  return p.width && "width: ".concat(p.width, ";");
}, function (p) {
  return p.mw && "min-width: ".concat(p.mw, "px");
}, function (p) {
  return p.mh && "min-height: ".concat(p.mh, "px");
});
Box.displayName = 'Box';
/**
 * Flex component.
 */

var Flex = styled(Box)(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  display: flex;\n\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  ", ";\n"])), function (p) {
  return p.align && "align-items: ".concat(p.align, ";");
}, function (p) {
  return p.column && "flex-direction: column;";
}, function (p) {
  return p.justify && "justify-content: ".concat(p.justify, ";");
}, function (p) {
  return p.row && "flex-direction: row;";
}, function (p) {
  return p.wrap && "flex-wrap: ".concat(p.wrap, ";");
}, function (p) {
  return p.mh && "min-height: ".concat(p.mh, ";");
});
var MaxFlex = styled(Flex)(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
/**
 * Text component.
 */

var commonTextStyles = css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (p) {
  return p.align && "text-align: ".concat(p.align, ";");
}, function (p) {
  return p.color && computeColorHelper(p.color);
}, function (p) {
  return p.fontSize && computeFontSizeHelper(p.fontSize);
}, function (p) {
  return p.italic && "font-style: italic;";
}, function (p) {
  return p.lineHeight && computeLineHeightHelper(p.lineHeight);
}, function (p) {
  return p.mediumBold && "font-weight: ".concat(mediumBold, ";");
}, function (p) {
  return p.preWrap && "white-space: pre-wrap;";
}, function (p) {
  return p.semiBold && "font-weight: ".concat(semiBold, ";");
});
var Text$1 = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n\n  ", ";\n  ", ";\n"])), primaryFont, function (p) {
  return commonSpaceStyles;
}, function (p) {
  return commonTextStyles;
});
Text$1.displayName = 'Text';
/**
 * Heading components.
 */

var Heading$1 = styled.h3(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 25px;\n  font-weight: ", ";\n  line-height: 32px;\n  margin: 0;\n\n  ", ";\n  ", ";\n"])), primaryFont, regular, function (p) {
  return commonSpaceStyles;
}, function (p) {
  return commonTextStyles;
});
Heading$1.displayName = 'Heading';
Heading$1.h2 = styled.h2(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 30px;\n  font-weight: ", ";\n  line-height: 40px;\n  margin: 0;\n\n  ", ";\n  ", ";\n"])), primaryFont, regular, function (p) {
  return commonSpaceStyles;
}, function (p) {
  return commonTextStyles;
});
Heading$1.h7 = styled.h6(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: 14px;\n  font-weight: ", ";\n  line-height: 24px;\n  margin: 0;\n\n  ", ";\n  ", ";\n"])), primaryFont, regular, function (p) {
  return commonSpaceStyles;
}, function (p) {
  return commonTextStyles;
});
/**
 * Mapping of spacing props to pixels.
 *
 * If the spacing integer is greater than 6, then
 * the intent is to use the provided integer as the pixel value.
 */

var space = [0, // 0
4, // 1
8, // 2
16, // 3
32, // 4
64, // 5
128 // 6
];

function computeSpacingHelper(sp) {
  if (typeof sp === 'number') {
    return "".concat(space[sp] || sp, "px}");
  } else if (typeof sp === 'string') {
    return "".concat(sp);
  }
}

function computeMarginBottomHelper(mb) {
  return "margin-bottom: ".concat(computeSpacingHelper(mb), ";");
}

function computeMarginLeftHelper(ml) {
  return "margin-left: ".concat(computeSpacingHelper(ml), ";");
}

function computeMarginRightHelper(mr) {
  return "margin-right: ".concat(computeSpacingHelper(mr), ";");
}

function computeMarginTopHelper(mt) {
  return "margin-top: ".concat(computeSpacingHelper(mt), ";");
}

function computeMarginXHelper(mx) {
  return "\n    margin-left: ".concat(computeSpacingHelper(mx), ";\n    margin-right: ").concat(computeSpacingHelper(mx), ";\n  ");
}

function computeMarginYHelper(my) {
  return "\n    margin-top: ".concat(computeSpacingHelper(my), ";\n    margin-bottom: ").concat(computeSpacingHelper(my), ";\n  ");
}

function computePaddingBottomHelper(pb) {
  return "padding-bottom: ".concat(computeSpacingHelper(pb), ";");
}

function computePaddingLeftHelper(pl) {
  return "padding-left: ".concat(computeSpacingHelper(pl), ";");
}

function computePaddingRightHelper(pr) {
  return "padding-right: ".concat(computeSpacingHelper(pr), ";");
}

function computePaddingTopHelper(pt) {
  return "padding-top: ".concat(computeSpacingHelper(pt), ";");
}

function computePaddingXHelper(px) {
  return "\n    padding-left: ".concat(computeSpacingHelper(px), ";\n    padding-right: ").concat(computeSpacingHelper(px), ";\n  ");
}

function computePaddingYHelper(py) {
  return "\n    padding-top: ".concat(computeSpacingHelper(py), ";\n    padding-bottom: ").concat(computeSpacingHelper(py), ";\n  ");
}

function computePaddingHelper(p) {
  return "padding: ".concat(computeSpacingHelper(p), ";");
}
/**
 * Mapping of font size prop to pixels.
 *
 * If the font size integer is greater than 6, then
 * the intent is to use the provided integer as the pixel value.
 */


var fontSizes = [12, // 0
14, // 1
16, // 2
20, // 3
25, // 4
30, // 5
50 // 6
];

function computeFontSizeHelper(fs) {
  if (typeof fs === 'number') {
    return "font-size: ".concat(fontSizes[fs] || fs, "px};");
  } else if (typeof fs === 'string') {
    return "font-size: ".concat(fs, ";");
  }
}
/**
 * Mapping of line height integers to pixels.
 *
 * If the line height integer is greater than 6, then
 * the intent is to use the provided integer as the pixel value.
 */


var lineHeights = [0, // 0
20, // 1
24, // 2
32, // 3
40, // 4
56 // 5
];

function computeLineHeightHelper(lh) {
  if (typeof lh === 'number') {
    return "line-height: ".concat(lineHeights[lh] || lh, "px};");
  } else if (typeof lh === 'string') {
    return "line-height: ".concat(lh, ";");
  }
}
/**
 * Colors to name mapping.
 */


var colorMap = {
  red: red,
  redTint: redTint,
  blue: blue,
  lightBlue: lightBlue,
  blueTint: blueTint,
  darkBlue: darkBlue,
  darkerBlue: darkerBlue,
  green: green,
  greenTint: greenTint,
  darkGreen: darkGreen,
  yellow: yellow,
  yellowTint: yellowTint,
  pink: pink,
  brown: brown,
  black: black,
  grey: grey,
  midGrey: midGrey,
  lightGrey: lightGrey,
  darkGrey: darkGrey,
  white: white,
  purple: purple,
  royalBlue: royalBlue
};

function computeColorHelper(color) {
  return "color: ".concat(colorMap[color] || color, ";");
}

function computeBackgroundColorHelper(color) {
  return "background-color: ".concat(colorMap[color] || color, ";");
}

export { Box, Flex, Heading$1 as Heading, MaxFlex, Text$1 as Text };